export const ZOOM_RECORDING_STATUS = {
  in_progress: "IN_PROGRESS",
  completed: "COMPLETED",
  failed: "FAILED",
} as const;
